// extracted by mini-css-extract-plugin
export default {"Work":"work_Work__lfxu7","Work_resize":"work_Work_resize__Ry-eF","Work_resize_block":"work_Work_resize_block__jurLs"};